import React from "react";

const Product = ({pageContext}) => {
    // console.log('мікророзмітка Product >>>>>', pageContext )

    const getAvailability = () => {
        // instock і onbackorder — товар фізично є в наявності (передзамовлення
        // теж виконується), тож обидва рахуються як InStock. Лише outofstock —
        // OutOfStock.
        return pageContext.stockStatus === "outofstock"
            ? "https://schema.org/OutOfStock"
            : "https://schema.org/InStock";
    };

    const getPriceValidUntil = () => {
        // Спробуємо знайти дату оновлення ціни, якщо вона доступна
        if (pageContext.priceUpdateDate) {
            return pageContext.priceUpdateDate;
        }

        // Якщо немає дати оновлення ціни, використовуємо дату оновлення продукту
        // або дату його створення, якщо вона доступна
        if (pageContext.modified) {
            // Додаємо 1 рік до дати останнього оновлення
            const modifiedDate = new Date(pageContext.modified);
            modifiedDate.setFullYear(modifiedDate.getFullYear() + 1);
            return modifiedDate.toISOString();
        }

        // Якщо жодна дата не доступна, використовуємо поточну дату + 1 рік
        const currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() + 1);
        return currentDate.toISOString();
    };



    const jsonLd = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": pageContext.title,
            "image": [
                pageContext.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src
            ],
            "description": pageContext.content,
            "sku": pageContext.sku,
            "gtin": pageContext.isbn,
            "brand": {
                "@type": "Brand",
                "name": "Molfar"
            },
            "offers": {
                "@type": "Offer",
                "url": pageContext.uri,
                "priceValidUntil": getPriceValidUntil(),
                "priceCurrency": "UAH",
                "availability": getAvailability(),
                "seller": {
                    "@type": "Organization",
                    "name": "Видавництво Molfar",
                    "url": "https://molfarpublishing.ua/" 
                },
                "price": pageContext.salePrice ? (pageContext.salePrice) : (pageContext.regularPrice)
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": pageContext.averageRating,
                "reviewCount": pageContext.commentCount
            },
            "review": pageContext.comments.nodes
            .filter(item => item.ratingComment) // Фільтруємо тільки коментарі з рейтингом
            .map((item, index) => ({
                "@type": "Review",
                "author": {
                    "@type": "Person",
                    "name": item.author.name
                },
                "datePublished": item.author.date,
                "reviewBody": item.author.content,
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": item.ratingComment
                }
            })),

        // "review": [
            //     {
            //         "@type": "Review",
            //         "author": {
            //             "@type": "Person",
            //             "name": "Ганна Ганнівна"
            //         },
            //         "datePublished": "2006-05-04",
            //         "reviewBody": "Неймовірно!",
            //         "reviewRating": {
            //             "@type": "Rating",
            //             "ratingValue": "5"
            //         }
            //     },
            //     {
            //         "@type": "Review",
            //         "author": {
            //             "@type": "Person",
            //             "name": "Андрій Андрійович"
            //         },
            //         "datePublished": "2006-06-15",
            //         "reviewBody": "Оце так-так!",
            //         "reviewRating": {
            //             "@type": "Rating",
            //             "ratingValue": "4"
            //         }
            //     }
            // ]
        }
    ;
    // JSON.stringify не екранує "<" — відгук з текстом "</script><script>..."
    // розірвав би JSON-LD-контекст і став реальним виконуваним тегом на
    // сторінці (той самий клас вразливості, що й у Comments.js/CreateOrder.js
    // XSS-фіксах). reviewBody/author.name — текст відгуку, який проходить
    // через цю розмітку без санітизації на відміну від Comments.js.
    return (
        <script
            className='Products'
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c') }}
        />
    );
};

export default Product;
